import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { MOBILE_APP as PRE } from 'main/util/i18n/namespaces'
import {
  ButtonContainer,
  ButtonsContainer,
  Clip,
  Container,
  ContentContainer,
  Image,
  ImageGroup,
  LeftImageContainer,
  RightImageContainer,
  TextContent,
} from './Intro.styles'

import { spacing } from 'main/ui'
import { Heading, Text } from 'main/ui/typography'
import AppStoreButton from './AppStoreButton'
import GooglePlayButton from './GooglePlayButton'

export default function Intro() {
  const { t } = useTranslation(NAMESPACE)
  return (
    <Container>
      <Clip>
        <ContentContainer>
          <TextContent>
            <Heading
              color="white"
              kind="large"
              css={{ marginBottom: `${spacing.majorScale(4)}px` }}
            >
              {t(`${PRE}-GET-THE-WONDERSCHOOL-MOBILE-APP`)}
            </Heading>
            <Text
              color="white"
              css={{ display: 'block', marginBottom: `${spacing.majorScale(3)}px` }}
            >
              {t(`${PRE}-WHEN-IT-COMES-TO-CREATING-EFFECTIVE`)}
            </Text>
            <ButtonsContainer>
              <ButtonContainer>
                <AppStoreButton />
              </ButtonContainer>
              <ButtonContainer>
                <GooglePlayButton />
              </ButtonContainer>
            </ButtonsContainer>
          </TextContent>
          <ImageGroup>
            <LeftImageContainer>
              <Image src="https://ucarecdn.com/265f9569-07b7-41c2-bdb9-bce2f5c5a47f/iPhoneXmessages2x.png" />
            </LeftImageContainer>
            <RightImageContainer>
              <Image src="https://ucarecdn.com/2cd2070b-1ee0-48f3-b83c-823d4bcbb3bb/iPhoneXactivity2x.png" />
            </RightImageContainer>
          </ImageGroup>
        </ContentContainer>
      </Clip>
    </Container>
  )
}
